import React from "react";

export default function TermsPage() {
  return (
    <div className="min-h-screen bg-gray-50 py-16 px-4">
      <div className="max-w-3xl mx-auto bg-white rounded-lg shadow-md p-8">
        {/* Header */}
        <h1 className="text-3xl font-bold text-gray-900 mb-6">
          GlowCanvas.io – Terms
        </h1>

        {/* Introduction */}
        <p className="text-gray-700 mb-6">
          By using GlowCanvas.io, you agree to these terms:
        </p>

        {/* Terms List */}
        <div className="space-y-4 mb-8">
          <div>
            <h2 className="font-semibold text-gray-900 mb-1">• Billing</h2>
            <p className="text-gray-700 pl-4">
              $49/year, billed annually, non-refundable. Cancel anytime; access
              continues until term ends.
            </p>
          </div>

          <div>
            <h2 className="font-semibold text-gray-900 mb-1">• Use</h2>
            <p className="text-gray-700 pl-4">
              Don't break laws or misuse GlowCanvas.
            </p>
          </div>

          <div>
            <h2 className="font-semibold text-gray-900 mb-1">• Content</h2>
            <p className="text-gray-700 pl-4">
              You own what you create. GlowCanvas doesn't store or keep your
              files.
            </p>
          </div>

          <div>
            <h2 className="font-semibold text-gray-900 mb-1">• Disclaimer</h2>
            <p className="text-gray-700 pl-4">
              GlowCanvas is provided "as is," with no guarantees or liability.
            </p>
          </div>

          <div>
            <h2 className="font-semibold text-gray-900 mb-1">• Changes</h2>
            <p className="text-gray-700 pl-4">
              Terms may update; continued use means acceptance.
            </p>
          </div>
        </div>

        {/* Contact */}
        <div className="pt-6 border-t border-gray-200">
          <p className="text-gray-700">
            <span className="font-semibold">Contact:</span>{" "}
            <a
              href="mailto:support@glowcanvas.io"
              className="text-blue-600 hover:underline"
            >
              support@glowcanvas.io
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}
